import _memoize from 'lodash/memoize';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { cacheResolver, FOCUSED_Z_INDEX, makeDefaultStylingContext, UNFOCUSED_Z_INDEX } from '../../utils/style';
import { BORDER_RADIUS, BORDER_WIDTH, SCALE_FOCUSED, BORDER_COLOR, INNER_BORDER_COLOR } from '../../utils/focus';
import { TRANSPARENT } from '../../utils/colors';

export const defaultContext = makeDefaultStylingContext();

export const LOCK_ICON_HEIGHT = {
  [HD]: 32,
  [FULL_HD]: 40,
};

export const ICON_HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const sizes = {
  [HD]: {
    w: 247,
    h: 139,
  },
  [FULL_HD]: {
    w: 302,
    h: 170,
  },
};

export const PADDING_LEFT = {
  [HD]: 12,
  [FULL_HD]: 16,
};

export const PADDING_RIGHT = {
  [HD]: 12,
  [FULL_HD]: 16,
};

export const PADDING_BOTTOM = {
  [HD]: 8,
  [FULL_HD]: 12,
};

export const ICON_PADDING_VERTICAL = 4;
export const ICON_PADDING_HORIZONTAL = 8;

export const getLockIconViewBox = _memoize(screenSize => ({ h: LOCK_ICON_HEIGHT[screenSize] }));

export const colors = {
  border: BORDER_COLOR,
  innerBorder: INNER_BORDER_COLOR,
};

export const getInitialStyle = ({ screenSize } = defaultContext) => {
  const borderSize = BORDER_WIDTH[screenSize];
  const borderOffset = borderSize * 2;

  return {
    zIndex: UNFOCUSED_Z_INDEX,
    Border: {
      w: sizes[screenSize].w + borderOffset,
      h: sizes[screenSize].h + borderOffset,
      x: -borderSize,
      y: -borderSize,
      color: TRANSPARENT,
      shader: {
        radius: BORDER_RADIUS[screenSize],
        outline: BORDER_WIDTH[screenSize],
        strokeColor: TRANSPARENT,
        innerColor: TRANSPARENT,
      },
    },
    Image: {
      ...sizes[screenSize],
      shader: {
        radius: BORDER_RADIUS[screenSize],
      },
    },
    LockIcon: {
      x: ICON_PADDING_HORIZONTAL,
      y: ICON_PADDING_VERTICAL,
    },
  };
};

export const getFocusedStyle = _memoize(
  ({ colorMode }) => ({
    zIndex: FOCUSED_Z_INDEX,
    Border: {
      smooth: {
        scale: SCALE_FOCUSED,
        'shader.strokeColor': colors.border[colorMode],
        'shader.innerColor': colors.innerBorder[colorMode],
        'shader.scale': SCALE_FOCUSED,
      },
    },
    Image: {
      smooth: {
        scale: SCALE_FOCUSED,
        'shader.scale': SCALE_FOCUSED,
      },
    },
  }),
  cacheResolver,
);

export const unFocusedStyle = {
  zIndex: UNFOCUSED_Z_INDEX,
  Border: {
    smooth: {
      scale: 1,
      'shader.strokeColor': TRANSPARENT,
      'shader.innerColor': TRANSPARENT,
      'shader.scale': 1.0,
    },
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0,
    },
  },
};
